





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { constants } from 'http2';

@Component
export default class MobileNavigationDrawer extends Vue {
    @Prop({ default: false }) public show!: boolean;

    public navigationList: any[] = [
        {
            key: 1,
            name: 'FAQ',
            path: '/faq',
        },
    ];


    public updateShow(isShow: boolean) {
        this.$emit('update:show', isShow);
    }

    public onNavigationDrawerClick(path: string) {
        this.$emit('update:show', false);
        this.$router.push(path);
    }

}
